(function ($) {

    var stretch_video = function() {
        $('.stretch-video').each(function () {
            var iframe = $(this).children('iframe'),
                    ratio = iframe.attr('height') / iframe.attr('width'),
                    new_width = $(this).width();

            if($(this).hasClass('no-height')){
                iframe.css({
                    'width': new_width
                });
            }else {
                iframe.css({
                    'width': new_width,
                    'height': new_width * ratio
                });
            }
        });

        $('iframe[allowfullscreen]').each(function () {
            var iframe = $(this),
                    ratio = iframe.attr('height') / iframe.attr('width'),
                    new_width = iframe.parents('.unreset-css').width();

            if (new_width) {

                iframe.css({
                    'width': new_width,
                    'height': new_width * ratio
                });
            }
        });
    };

    $(window)
            .on('resize', Foundation.util.throttle(stretch_video, 300))
            .on('load-page', stretch_video);

    stretch_video();

})
(jQuery);